import { TableCellType } from "components/LazyTable";
import SortableTable from "components/SortableTable";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import { useIntl } from "react-intl";
import {
  ListRequestOfSkuStudyFieldFilter,
  ListResponseOfSkuStudyField,
} from "services/KnowfullyAdminClient";
import { SkuStudyFieldWithId } from "types/sku-related-types";

const SkuStudyFields = ({ skuId }: { skuId: string }) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const { data, isFetching } = useStrictQuery<ListResponseOfSkuStudyField>(
    ["skuStudyFields", skuId],
    () =>
      skuService.getSkuStudyFields(
        skuId,
        ListRequestOfSkuStudyFieldFilter.fromJS({
          sortField: "createdOn",
          sortDescending: true,
        })
      ),
    { enabled: !!skuId }
  );

  const cells: Array<TableCellType> = [
    {
      accessor: "studyField.name",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "skuStudyFieldLabel" }),
    },
    {
      accessor: "credits",
      align: "left",
      width: 0,
      type: "text",
      label: t({ id: "credits" }),
    },
  ];

  return (
    <SortableTable
      {...{
        rows: data?.data! as SkuStudyFieldWithId[],
        loading: isFetching,
        dense: true,
        cells,
        tableRowPerPage: 5,
        defaultOrderBy: "createdOn",
      }}
    />
  );
};

export default withErrorBoundary(SkuStudyFields);
